import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import CustomerProfileViewComponent from '../../../../components/CustomerProfileViewComponent';
import {
  CorporateAttributeConf,
  IndividualAttributeConf
} from './customerProfileConfig';
import style from './index.scss';

const getProfileConf = (attrConf, gs) => {
  return gs && gs.widgetConfig
    ? gs.widgetConfig
        .filter((c) => c.columnVisibility)
        .sort((a, b) => a.columnIndex - b.columnIndex)
        .map((wc) =>
          wc.columnDetail
            .filter((item) => item.visibility)
            .map((item) => {
              return {
                ...attrConf[item.itemName],
                label: item.itemLabel,
                attribute: item.itemName,
                priority: item.itemIndex + 1
              };
            })
        )
    : [];
};
/**
 * customerProfile Table component
 * @param customerProfile
 * @returns {*}
 * @constructor
 */
const CustomerProfileView = ({
  customerProfileData,
  GSConfigIndividual,
  GSConfigCorporate
}) => {
  const { customerType, fetched, isFetching } = customerProfileData || {};

  let CustomerProfileBody = null;
  if (customerType === 'CORPORATE' || customerType === 'C') {
    CustomerProfileBody = (
      <CustomerProfileViewComponent
        profileConf={getProfileConf(CorporateAttributeConf, GSConfigCorporate)}
        customerProfile={customerProfileData}
        crsVersion={true}
      />
    );
  }

  if (customerType === 'INDIVIDUAL' || customerType === 'I') {
    CustomerProfileBody = (
      <CustomerProfileViewComponent
        profileConf={getProfileConf(
          IndividualAttributeConf,
          GSConfigIndividual
        )}
        customerProfile={customerProfileData}
        crsVersion={true}
      />
    );
  }

  return (
    <div className={classnames(style.card_dark, 'card')}>
      {isFetching && (
        <div className={style.loading}>Fetching Customer Profile...</div>
      )}
      {fetched && CustomerProfileBody}
    </div>
  );
};
/**
 * Proptypes
 * @type {{customerProfile: shim}}
 */
CustomerProfileView.propTypes = {
  customerProfileData: PropTypes.object,
  GSConfigIndividual: PropTypes.object,
  GSConfigCorporate: PropTypes.object
};

export default CustomerProfileView;
